<ng-container [formGroup]="formGroup">
  <section id="field-options">
    <table class="table-full-width table-striped table-td-border-right">
      <tr>
        <td>
          <h2 class="heading-underline">Date format</h2>
          <label>Enter a date format to appear in your documents</label>
          <input id="date-format" class="full-width" type="text" formControlName="dateFormat" placeholder='e.g. "dd MM yyyy"' />
          <!-- TODO: CHECK THIS, IS THIS ACTUALLY TRUE? -->
          <small class="info-tip">
            <mat-icon fontIcon="info_outline"></mat-icon>
            Leaving this blank will default to "MMM dd, yyyy" e.g. "Dec 10, 1993"
          </small>
        </td>
      </tr>
      <tr>
        <td>
          <h2 class="heading-underline">Number format</h2>
          <label>Set the defaults applied to number fields as they are added to a template</label>
          <table class="number-format">
            <tr class="number-format-row">
              <td>Decimal places</td>
              <td>
                <input
                  id="number-decimal-places"
                  class="decimal-places"
                  type="number"
                  min="0"
                  title="How many decimal places to show"
                  formControlName="numberDecimalPlaces"
                />
              </td>
            </tr>
            <tr class="number-format-row">
              <td>Decimal separator</td>
              <td colspan="2">
                <mat-button-toggle-group
                  id="number-decimal-separator"
                  aria-label="Decimal separator style"
                  formControlName="numberDecimalSeparator"
                  [hideSingleSelectionIndicator]="true"
                >
                  <mat-button-toggle [value]="numberFormatSeparator.POINT">2.01</mat-button-toggle>
                  <mat-button-toggle [value]="numberFormatSeparator.COMMA">2,01</mat-button-toggle>
                </mat-button-toggle-group>
              </td>
            </tr>
            <tr class="number-format-row">
              <td>Thousands separator</td>
              <td colspan="2">
                <mat-button-toggle-group
                  id="number-thousands-separator"
                  aria-label="Thousands separator style"
                  formControlName="numberThousandsSeparator"
                  [hideSingleSelectionIndicator]="true"
                >
                  <mat-button-toggle [value]="numberFormatSeparator.POINT">1.000</mat-button-toggle>
                  <mat-button-toggle [value]="numberFormatSeparator.COMMA">1,000</mat-button-toggle>
                  <mat-button-toggle [value]="numberFormatSeparator.NONE">1000</mat-button-toggle>
                  <mat-button-toggle [value]="numberFormatSeparator.WHITESPACE">1 000</mat-button-toggle>
                </mat-button-toggle-group>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      @for (fields of emptyFieldsFormArray.controls; track $index; let i = $index) {
        <tr>
          <td class="default-field">
            <mat-icon
              fontIcon="close"
              id="remove-empty_field-{{ i }}"
              class="delete-field-hover"
              (click)="onRemoveClick(i)"
              [matTooltip]="'Remove this'"
              matTooltipShowDelay="500"
            ></mat-icon>
            <mat-select placeholder="choose type" [formControl]="getFormControl(i, 'type')">
              @for (option of emptyFieldSelect; track $index) {
                <mat-option [value]="option">{{ emptyFieldType[option] }}</mat-option>
              }
            </mat-select>
            <input class="input-field" placeholder="Field" [formControl]="getFormControl(i, 'key')" />
            <input class="input-field" placeholder="Value" [formControl]="getFormControl(i, 'value')" />
          </td>
        </tr>
      }
      <tr>
        <td>
          <ng-container>
            <button id="add-empty-field" theme="small" type="button" (click)="onAddEmptyFieldClick()">Add blank field default</button>
          </ng-container>
        </td>
      </tr>
    </table>
  </section>
</ng-container>
